module.exports = __webpack_public_path__ + "assets/img/favorite.8f4c5852.svg";